import styled from 'styled-components';
import ReactModal from 'react-modal';
import { ComponentType } from 'react';
import { color, spacing, media } from '~/theme';

export const StyledModal = styled(ReactModal as ComponentType<ReactModal['props']>)`
    position: fixed;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100vh;
    max-width: 100vw;
    margin: ${spacing.spacing0};
    transform: translate(-50%, -50%);
    background: ${color.palette.white};
    overflow: auto;
    outline: transparent solid 4px;
    padding: ${spacing.spacing5} ${spacing.spacing4};
    box-shadow: rgba(26, 26, 26, 0.6) 0 0 2px;
    transition: box-shadow 0.1s ease-in-out 0s;

    overlay: {
        background: rgba(0, 0, 0, 0.65);
    }

    @media ${media.small} {
        height: auto;
        max-height: 95vh;
        max-width: 95vw;
    }

    @media ${media.medium} {
        max-height: 90vh;
    }

    @media ${media.large} {
        padding: ${spacing.spacing7} ${spacing.spacing5};
        height: auto;
        max-width: 1200px;
    }
`;

export const ModalBody = styled.div`
    margin-top: ${spacing.spacing4};

    p {
        font-size: 22px;
        line-height: 35px;
    }
`;

export const LeadText = styled.p`
    font-size: 1.25rem;
    line-height: 1.6;

    @media ${media.small} {
        font-size: 1.375rem;
    }
`;

export const ModalFooter = styled.div`
    margin-top: ${spacing.spacing8};
`;

export default {
    StyledModal,
    ModalBody,
    LeadText,
    ModalFooter,
};
